<template>
<!-- registrStatus 报名状态 1:进入直播间 2:已报名,未审核 3:报名 4:已报名,审核中 -->
  <div id="content"
       class="container-live">
    <header>
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('onlineTraining')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('livenoticeList')">直播.培训</div>
      </div>
    </header>
    <div class="certificate-con">
      <div class="livebanner"
           v-if="imgList.length > 0">
        <el-carousel trigger="click"
                     :interval="6000"
                     height="520px">
          <el-carousel-item v-for="item in imgList"
                            height="520px"
                            :key="item.id">
            <img :src="item.carouselUrl"
                 alt=""
                 style="width:100%;heigth:100%;cursor:pointer"
                 @click.stop="handleRegister(item)" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div style="height:10px;width:100%;background:rgb(247, 248, 250)"
           v-if="imgList.length > 0"></div>
      <!-- 报告列表 -->
      <div class="search-list">
        <ul class="search-list-con"
            v-if="dataList.length">
          <li v-for="data in dataList"
              :key="data.id">
            <div class="list-img">
              <img v-if="data.url"
                   :src="data.url || imgUrl" />
              <img v-if="!data.url"
                   :src="imgUrl" />
              <div class="status">
                <span v-if="data.status === 1"><img src="../../../../assets/img/live/live.png"
                       width="16px"
                       height="16px" />正在直播...</span>
                <span v-else-if="data.status === 0"><img src="../../../../assets/img/live/time.png"
                       width="16px"
                       height="16px" />课程即将开始...</span>
                <span v-else-if="data.status === 2"><img src="../../../../assets/img/live/end.png"
                       width="16px"
                       height="16px" />课程已结束</span>
              </div>
            </div>
            <div class="list-con">
              <p>
                课程名称：
                <span>{{data.title}}</span>
              </p>
              <p style="margin:10px 0">
                课程类型：
                <span>{{data.type=== 1 ? '直播' : '专题'}}</span>
              </p>
              <p style="margin:10px 0">
                直播时间：
                <span>{{data.liveTime}}</span>
              </p>
              <p>
                培训讲师：
                <span>{{data.teacherName}}</span>
              </p>
              <p style="margin:10px 0">
                课程简介：
                <span>{{data.marks}}</span>
              </p>
            </div>
            <div class="cf jc list-btn">
              <div v-if="data.type=== 2" class="price-area">
                <div class="pricrclass pr-line">原价：{{(data.sellingPrice || 0).toFixed(2)}}</div>
                <div class="pricrclass">活动价：{{(data.activityPrice || 0).toFixed(2)}}</div>
              </div>
              <div class="apply-text"
                   v-if="data.type ==2 && data.status != 2 && data.registrStatus == 1">报名成功</div>
              <div class="apply-text"
                   v-else-if="data.type ==2 && data.status == 1 && data.registrStatus == 3">进行中</div>
              <div class="jionButton endclass"
                   v-else-if="data.status === 2">课程已结束</div>
              <div class="apply-text"
                   v-else-if="data.registrStatus == 2 || data.registrStatus == 4"><img src="@/assets/img/live/apply.png"
                     width="16px"
                     height="16px" />已报名,未审核</div>
              <div class="jionButton" v-else-if="data.registrStatus ==3" @click="handleRegister(data)">报名</div>
              <div class="jionButton"
                   :class="{'endclass': data.status !== 1}"
                   v-else-if="data.registrStatus ==1"
                   @click="handlejoinClick(data)">进入直播</div>
              <div class="jionButton"
                   v-if="data.type ==2 && data.status == 1 && data.registrStatus == 3"
                   @click="handleRegister(data)">报名</div>
              <div class="jionButton"
                  v-if="[2,4].includes(Number(data.registrStatus)) && data.type ==2 &&(data.activityPrice  > 0) && !data.paymentTime"
                  @click="payHandle(data)"
              >去支付</div>
            </div>
          </li>
        </ul>
        <div v-else
             style="text-align:center">
          <img src="@/assets/img/good/noGood.png"
               alt="暂无数据" />
        </div>
      </div>
      <!-- 分页 -->
      <el-pagination background
                     style="margin-top:10px;text-align: center;"
                     layout="prev, pager, next, total, jumper, slot"
                     prev-text="上一页"
                     next-text="下一页"
                     @current-change="getList"
                     :current-page="currentPage"
                     :page-size="pageSize"
                     :pager-count="5"
                     :total="total"></el-pagination>
    </div>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      dataForm: {
        name: '',
        phone: ''
      },
      imgList: [],
      dataList: [],
      currentPage: 1,
      pageSize: 10,
      total: 1,
      imgUrl: require('@/assets/img/占位图_en.png'),
      dataListLoading: false
    }
  },
  mounted () {
    this.getList()
    this.getImgList()
  },
  methods: {
    // 在线报名
    handleRegister (data) {
      if (getAccessToken()) {
        this.$router.push({
          name: 'onLineSignUp',
          query: {
            id: data.id,
            title: data.title,
            type: data.type,
            qualification: data.qualification,
            activityPrice: data.activityPrice,
            liveTime: data.liveTime
          }
        })
      } else {
        this.$router.push('/login')
      }
    },
    // 加入直播
    handlejoinClick (row) {
      if (row.status !== 1) {
        return false
      }
      if (getAccessToken()) {
        this.$router.push({
          name: 'studentLive',
          query: {
            id: row.id,
            title: row.title
          }
        })
      } else {
        this.$router.push('/login')
      }
    },
    // 支付结算
    payHandle (row) {
      this.$router.replace({ name: 'settlement', query: { goodsId: row.id, type: 6 } })
    },
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'livenoticeList') {
        this.$router.push({ name: 'livenoticeList' })
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.getList(1)
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    getList (page = this.currentPage) {
      this.currentPage = page
      this.$http.post(`/front/train/neteaseLiveTrain/homeLiveClassList`, {
        page: page,
        limit: this.pageSize
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.total = res.data.count
          this.dataList = res.data.data
        } else {
          this.total = 0
          this.dataList = []
        }
      }).catch(() => {
        this.total = 0
        this.dataList = []
      })
    },
    getImgList () {
      this.$http.post(`/front/train/neteaseLiveTrain/homeLiveClassCarouselList`, {
        userId: ''
      }).then(({ data: res }) => {
        if (res.code === 0) {
          if (res.data && res.data.length > 0) {
            this.imgList = res.data
          } else {
            this.imgList = []
          }
        } else {
          this.imgList = []
        }
      }).catch(() => { })
    }
  }
}
</script>
<style scoped lang="scss">
.container-live {
  width: 1190px;
  margin: 0 auto;
  .livebanner {
    width: 100%;
    height: 520px;
  }
  .price-area{
    width: 120px;
    margin: 0 auto;
  }
  .jionButton {
    position: relative;
    // top: 45%;
    width: 120px;
    height: 30px;
    line-height: 30px;
    background: #1e64a9;
    color: #fff;
    text-align: center;
    margin: 0 auto;
    // border-radius:10px;
    cursor: pointer;
  }
  .pricrclass{
    line-height: 26px;
    font-size: 14px;
    font-weight: bold;
  }
  .pr-line{
    text-decoration: line-through red;
  }
  .endclass {
    background: #999999;
    cursor: no-drop;
  }
  .apply-text {
    position: relative;
    // top: 45%;
    margin: 0 auto;
    line-height: 26px;
    width: 120px;
    // font-size: 16px;
    color: #1d65a8;
    // text-align: center;
  }
  .search {
    padding: 20px 30px;
    height: 70px;
    text-align: center;
  }
  .search-list {
    min-height: 400px;
    padding: 20px 20px;
    margin-top: 10px;
  }
  .search-list-con {
    margin: 0 auto;
    min-height: 400px;
  }
  .search-list-con li {
    width: 100%;
    // height: 170px;
    padding: 15px 30px;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
  }
  .list-img {
    flex-shrink: 0;
    width: 200px;
    // height: 130px;
  }
  .list-img img {
    border: 1px solid #eee;
    width: 180px;
    height: 100px;
  }
  .list-img .status {
    text-align: center;
    height: 20px;
    margin: 20px auto 0;
    color: #1d65a8;
  }
  .list-img .status img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  .list-con {
    // width: 500px;
    // height: 140px;
    // float: left;
    // padding: 10px;
    padding-left: 30px;
    color: #333;
    flex-grow: 1;
  }
  .list-btn {
    width: 200px;
    flex-shrink: 0;
    position: relative;
    // height: 130px;
    // float: right;
    // text-align: right;
    // padding-top: 80px;
  }
}

.certificate-con {
  width: 100%;
  min-height: 400px;
  background: #fff;
}

.list-con h3 {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
</style>
